import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledSelectedFilters = styled('div')(
  ({ theme }) => css`
    padding: 0 8px;
    display: flex;
    gap: 8px;
    overflow: auto;

    ::-webkit-scrollbar {
      display: none;
    }

    .MuiChip-root {
      padding: 8px 12px;
      border-radius: 32px;
      border: 1px solid ${theme.palette.accent.oceanBlue};
      background: rgba(0, 139, 248, 0.05);
      height: 38px;
      color: ${theme.palette.accent.oceanBlue};
      text-align: center;
      font-family: ${theme.typography.button.fontFamily};
      font-size: ${theme.typography.button.fontSize};
      font-weight: ${theme.typography.button.fontWeight};
      line-height: ${theme.typography.button.lineHeight};

      &:hover {
        background: rgba(0, 139, 248, 0.05);
      }

      .MuiChip-label {
        padding: 0;
      }

      .icon {
        color: ${theme.palette.accent.oceanBlue};
        font-size: 1.25rem;
        font-weight: 500;
      }
    }

    .MuiChip-root:hover {
      background: rgba(0, 139, 248, 0.05);
    }
  `
);
